<template>
  <div :class="$style.container">
    <app-panel flex :class="$style.panel">
      <div :class="$style.body">
        <div :class="$style.header">
          <div :class="$style.title">Заявки</div>

          <div :class="$style.buttons">
            <app-button icon="NewFileIcon" size="small" type="border" @click="$router.push({name: 'uc_issues_create'})">
              Создать заявку
            </app-button>

            <div class="ml-2">
              <app-dropdown :menuClass="$style.exportMenu">
                <app-button :class="$style.exportButton" icon="DownloadFile" size="small" type="border">
                  Экспорт в csv
                  <div v-if="isExportLoading" class="block-loading" />
                </app-button>

                <div slot="menu">
                  <ul class="client-select-apart__list">
                    <li :class="$style.exportItem" @click="exportIssues()">Весь журнал</li>
                    <li :class="$style.exportItem" @click="exportIssues(true)">Аварийные заявки</li>
                  </ul>
                </div>
              </app-dropdown>
            </div>

            <app-button class="ml-2" icon="TasksIcon" size="small" type="border" @click="openGeneratePlans">
              Генерация план нарядов
            </app-button>
          </div>
        </div>

        <div :class="$style.hint">
          <template v-if="filter.users_id.length">
            Заявки пользователя {{ owner && owner.name }}
            <app-button class="ml-4" type="border" @click="onResetUser">Показать все</app-button>
          </template>
          <!--          <template v-else-if="!filter.status_id.includes(2)">-->
          <!--            <template v-if="issuesInStatusCount[2]">-->
          <!--              Внимание! Есть заявки ({{ issuesInStatusCount[2] }}), не распределенные по исполнителям.-->
          <!--              <app-button class="ml-4" type="border" @click="onShowUnassigned">Показать</app-button>-->
          <!--            </template>-->
          <!--          </template>-->
          <!--          <template v-else-if="!filter.status_id.includes(1)">-->
          <!--            <template v-if="issuesInStatusCount[1]">-->
          <!--              Новых заявок: {{ issuesInStatusCount[1] }}-->
          <!--              <app-button class="ml-4" type="border" @click="onShowNew">Показать</app-button>-->
          <!--            </template>-->
          <!--          </template>-->
        </div>

        <div :class="$style.types">
          <div :class="$style.typeTitle">Статус:</div>
          <div
            :class="[$style.type, !filter.status_id.length && $style.typeActive]"
            :style="{'--color': '#000' }"
            @click="onToggleStatus('all')"
          >
            <div :class="$style.typeText">Все</div>
            <div v-if="getAllUnread()" :class="$style.typeLabel">+{{ getAllUnread() }}</div>
          </div>
          <div
            v-for="status in statuses"
            :key="status.id"
            :class="[$style.type, filter.status_id.includes(status.id) && $style.typeActive]"
            :style="{'--color': status.color }"
            @click="onToggleStatus(status)"
          >
            <div :class="$style.typeText">{{ status.name }}</div>
            <div v-if="getStatusUnread(status.id)" :class="$style.typeLabel">
              +{{ getStatusUnread(status.id) }}
            </div>
          </div>
        </div>

        <div :class="$style.row">
          <div :class="$style.rowLabel">Поиск:</div>
          <div :class="$style.rowContent">
            <div :class="$style.search">
              <input
                :class="$style.searchInput"
                placeholder="№, заявитель, номер помещения, тема, описание…"
                v-model="searchString"
                @keydown.enter="onSearch"
              />
              <app-icon :class="$style.searchIcon" name="SearchIcon" size="14px" />
              <button v-if="searchString" :class="$style.searchClear" @click="onSearchClear">
                <app-icon :class="$style.searchClearIcon" name="XIcon" size="12px" />
              </button>
            </div>
          </div>
        </div>

        <div :class="$style.row">
          <div :class="$style.rowLabel">Фильтры:</div>
          <div :class="$style.rowContent">
            <div :class="$style.filters">
              <tasks-filter name="Исполнитель" v-model="filter.performer_id" :values="performers" />
              <tasks-filter name="Дом" v-model="filter.buildings_id" :values="houses" label="address" />
              <tasks-filter name="Тип" v-model="filter.category_id" :values="categories" />
              <button :class="$style.filterClear" @click="onClearAll">Очистить все</button>
            </div>
          </div>
        </div>
        <div :class="$style.row">
          <div :class="$style.rowLabel">Сортировка по дате:</div>
          <div :class="$style.rowContent">
            <issue-sort-filter :sort="filter.sort" :order="filter.order" @update="onSetSort" />
          </div>
        </div>

        <!--        <div :class="$style.types">-->
        <!--          <div :class="$style.typeTitle">Тип:</div>-->
        <!--          <div-->
        <!--            :class="[$style.type, !filter.category_id.length && $style.typeActive]"-->
        <!--            :style="{'&#45;&#45;color': '#000' }"-->
        <!--            @click="onToggleCategory('all')"-->
        <!--          >-->
        <!--            <div :class="$style.typeText">Все</div>-->
        <!--            <div v-if="getAllUnread()" :class="$style.typeLabel">+{{ getAllUnread() }}</div>-->
        <!--          </div>-->
        <!--          <div-->
        <!--            v-for="category in categories"-->
        <!--            :key="category.id"-->
        <!--            :class="[$style.type, filter.category_id.includes(category.id) && $style.typeActive]"-->
        <!--            :style="{'&#45;&#45;color': category.color }"-->
        <!--            @click="onToggleCategory(category)"-->
        <!--          >-->
        <!--            <div :class="$style.typeText">{{ category.name }}</div>-->
        <!--            <div v-if="getCategoryUnread(category.id)" :class="$style.typeLabel">-->
        <!--              +{{ getCategoryUnread(category.id) }}-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div :class="$style.filtersTitle">-->
        <!--          Фильтры-->
        <!--          <button :class="$style.filterClear" @click="onClearAll">Очистить все</button>-->
        <!--        </div>-->
        <!--        <div :class="$style.filters">-->
        <!--          &lt;!&ndash;          <div :class="$style.filter">&ndash;&gt;-->
        <!--          &lt;!&ndash;            <elsa-v-select&ndash;&gt;-->
        <!--          &lt;!&ndash;              :class="$style.filterStatus"&ndash;&gt;-->
        <!--          &lt;!&ndash;              :options="statuses"&ndash;&gt;-->
        <!--          &lt;!&ndash;              v-model="tableFilterStatusId"&ndash;&gt;-->
        <!--          &lt;!&ndash;              label="name"&ndash;&gt;-->
        <!--          &lt;!&ndash;              :reduce="item => item.id"&ndash;&gt;-->
        <!--          &lt;!&ndash;              style-type="small"&ndash;&gt;-->
        <!--          &lt;!&ndash;              :clearable="false"&ndash;&gt;-->
        <!--          &lt;!&ndash;              :append-to-body="true"&ndash;&gt;-->
        <!--          &lt;!&ndash;              html-label="Статус"&ndash;&gt;-->
        <!--          &lt;!&ndash;            >&ndash;&gt;-->
        <!--          &lt;!&ndash;              <template #selected-option-container="{ option, deselect, multiple, disabled }">&ndash;&gt;-->
        <!--          &lt;!&ndash;                    <span :class="$style.filterSelected" v-if="option.id === filter.status_id[0]">&ndash;&gt;-->
        <!--          &lt;!&ndash;                      {{ option.name }}&ndash;&gt;-->
        <!--          &lt;!&ndash;                      <template v-if="filter.status_id.length > 1">+{{ filter.status_id.length - 1 }}</template>&ndash;&gt;-->
        <!--          &lt;!&ndash;                      <button&ndash;&gt;-->
        <!--          &lt;!&ndash;                        @mousedown.stop=""&ndash;&gt;-->
        <!--          &lt;!&ndash;                        @click.capture.stop="filter.status_id = []"&ndash;&gt;-->
        <!--          &lt;!&ndash;                        type="button"&ndash;&gt;-->
        <!--          &lt;!&ndash;                        :class="$style.filterDeselect"&ndash;&gt;-->
        <!--          &lt;!&ndash;                      >&ndash;&gt;-->
        <!--          &lt;!&ndash;                        <app-icon name="XIcon" size="8px" />&ndash;&gt;-->
        <!--          &lt;!&ndash;                      </button>&ndash;&gt;-->
        <!--          &lt;!&ndash;                    </span>&ndash;&gt;-->
        <!--          &lt;!&ndash;                <span v-else />&ndash;&gt;-->
        <!--          &lt;!&ndash;              </template>&ndash;&gt;-->
        <!--          &lt;!&ndash;            </elsa-v-select>&ndash;&gt;-->
        <!--          &lt;!&ndash;          </div>&ndash;&gt;-->

        <!--          <div :class="$style.filter">-->
        <!--            <elsa-v-datepicker-->
        <!--              :container-class="$style.filterDate"-->
        <!--              v-model="filter.created_at"-->
        <!--              label="Дата создания"-->
        <!--              style-type="small"-->
        <!--            />-->
        <!--          </div>-->

        <!--          <div :class="$style.filter">-->
        <!--            <elsa-v-select-->
        <!--              :class="$style.filterHouse"-->
        <!--              :options="houses"-->
        <!--              v-model="tableFilterBuildingId"-->
        <!--              label="address"-->
        <!--              :reduce="item => item.id"-->
        <!--              style-type="small"-->
        <!--              :clearable="false"-->
        <!--              :append-to-body="true"-->
        <!--              html-label="Адрес"-->
        <!--            >-->
        <!--              <template #selected-option-container="{ option, deselect, multiple, disabled }">-->
        <!--                    <span :class="$style.filterSelected" v-if="option.id === filter.buildings_id[0]">-->
        <!--                      {{ option.address }}-->
        <!--                      <template v-if="filter.buildings_id.length > 1">+{{ filter.buildings_id.length - 1 }}</template>-->
        <!--                      <button-->
        <!--                        @mousedown.stop=""-->
        <!--                        @click.capture.stop="filter.buildings_id = []"-->
        <!--                        type="button"-->
        <!--                        :class="$style.filterDeselect"-->
        <!--                      >-->
        <!--                        <app-icon name="XIcon" size="8px" />-->
        <!--                      </button>-->
        <!--                    </span>-->
        <!--                <span v-else />-->
        <!--              </template>-->
        <!--            </elsa-v-select>-->
        <!--          </div>-->

        <!--          <div :class="$style.filter">-->
        <!--            <elsa-v-select-->
        <!--              :class="$style.filterPerformer"-->
        <!--              :options="performers"-->
        <!--              v-model="tableFilterPerformerId"-->
        <!--              label="name"-->
        <!--              :reduce="item => item.id"-->
        <!--              style-type="small"-->
        <!--              :clearable="false"-->
        <!--              :append-to-body="true"-->
        <!--              html-label="Исполнитель"-->
        <!--            >-->
        <!--              <template #selected-option-container="{ option, deselect, multiple, disabled }">-->
        <!--                    <span :class="$style.filterSelected" v-if="option.id === filter.performer_id[0]">-->
        <!--                      {{ option.name }}-->
        <!--                      <template v-if="filter.performer_id.length > 1">+{{ filter.performer_id.length - 1 }}</template>-->
        <!--                      <button-->
        <!--                        @mousedown.stop=""-->
        <!--                        @click.capture.stop="filter.performer_id = []"-->
        <!--                        type="button"-->
        <!--                        :class="$style.filterDeselect"-->
        <!--                      >-->
        <!--                        <app-icon name="XIcon" size="8px" />-->
        <!--                      </button>-->
        <!--                    </span>-->
        <!--                <span v-else />-->
        <!--              </template>-->
        <!--            </elsa-v-select>-->
        <!--          </div>-->

        <!--          &lt;!&ndash;          <div :class="$style.filter">&ndash;&gt;-->
        <!--          &lt;!&ndash;            <elsa-v-select&ndash;&gt;-->
        <!--          &lt;!&ndash;              :class="$style.filterCategory"&ndash;&gt;-->
        <!--          &lt;!&ndash;              :options="categories"&ndash;&gt;-->
        <!--          &lt;!&ndash;              v-model="tableFilterCategoryId"&ndash;&gt;-->
        <!--          &lt;!&ndash;              label="nameShort"&ndash;&gt;-->
        <!--          &lt;!&ndash;              :reduce="item => item.id"&ndash;&gt;-->
        <!--          &lt;!&ndash;              style-type="small"&ndash;&gt;-->
        <!--          &lt;!&ndash;              :append-to-body="true"&ndash;&gt;-->
        <!--          &lt;!&ndash;              :clearable="false"&ndash;&gt;-->
        <!--          &lt;!&ndash;              html-label="Тип"&ndash;&gt;-->
        <!--          &lt;!&ndash;            >&ndash;&gt;-->
        <!--          &lt;!&ndash;              <template #selected-option-container="{ option, deselect, multiple, disabled }">&ndash;&gt;-->
        <!--          &lt;!&ndash;                    <span :class="$style.filterSelected" v-if="option.id === filter.category_id[0]">&ndash;&gt;-->
        <!--          &lt;!&ndash;                      {{ option.nameShort }}&ndash;&gt;-->
        <!--          &lt;!&ndash;                      <template v-if="filter.category_id.length > 1">+{{
          &ndash;&gt;-- >
          < !-- &lt; ! & ndash;                          filter.category_id.length - 1 & ndash;&gt;-- >
          < !-- &lt; ! & ndash;
        }}</template>&ndash;&gt;-->
        <!--          &lt;!&ndash;                      <button&ndash;&gt;-->
        <!--          &lt;!&ndash;                        @mousedown.stop=""&ndash;&gt;-->
        <!--          &lt;!&ndash;                        @click.capture.stop="filter.category_id = []"&ndash;&gt;-->
        <!--          &lt;!&ndash;                        type="button"&ndash;&gt;-->
        <!--          &lt;!&ndash;                        :class="$style.filterDeselect"&ndash;&gt;-->
        <!--          &lt;!&ndash;                      >&ndash;&gt;-->
        <!--          &lt;!&ndash;                        <app-icon name="XIcon" size="8px" />&ndash;&gt;-->
        <!--          &lt;!&ndash;                      </button>&ndash;&gt;-->
        <!--          &lt;!&ndash;                    </span>&ndash;&gt;-->
        <!--          &lt;!&ndash;                <span v-else />&ndash;&gt;-->
        <!--          &lt;!&ndash;              </template>&ndash;&gt;-->
        <!--          &lt;!&ndash;            </elsa-v-select>&ndash;&gt;-->
        <!--          &lt;!&ndash;          </div>&ndash;&gt;-->
        <!--        </div>-->
        <div :class="$style.total">Всего: {{ issuesCount }}</div>

        <VuePerfectScrollbar
          ref="scroll"
          :class="$style.tableWrapper"
          @ps-y-reach-end="loadNextPage"
        >
          <table :class="$style.table">
            <thead>
            <tr>
              <th>Статус</th>
              <th>№, дата создания</th>
              <th>Адрес</th>
              <th>Сообщение</th>
              <th>Исполнитель</th>
              <th class="text-right">Категория</th>
            </tr>
            </thead>

            <tbody v-if="!issues.length && !isIssuesLoading">
            <tr>
              <td colspan="6" class="text-center p-4">Журнал заявок пуст</td>
            </tr>
            </tbody>

            <tbody v-else>
            <IssuesRow v-for="item in issues" :key="item.id" :item="item" />
            </tbody>
          </table>

          <div v-if="isIssuesLoading" class="p-4">
            <div class="block-loading" />
          </div>
        </VuePerfectScrollbar>
      </div>
    </app-panel>

    <GeneratePlanPopup ref="generatePlans" />
    <!--    <HistoryPopup ref="historyPopup" />-->
  </div>
</template>

<script>
import parseJSON           from "@/utils/parseJSON";
import exportToCSV         from "@/helpers/exportToCSV";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import dateFormat          from 'date-fns/format';
import dateParse           from 'date-fns/parse';
import dateStartOfDay      from 'date-fns/startOfDay';
import dateEndOfDay        from 'date-fns/endOfDay';
import declOfNum           from "@/functions/declOfNum";
import generateFullAddress from "@/functions/generateFullAddress";
import IssueSortFilter     from "@/components/issues/IssueSortFilter";
import TasksFilter         from "@/components/tasks/TasksFilter";
import IssuesRow           from "@/components/issues/IssuesRow";
import GeneratePlanPopup   from "@/components/employee/issues/GeneratePlanPopup";
// import HistoryPopup        from "@/components/employee/tasks/HistoryPopup";

const isDefaultSort = ( filter ) =>
  (!filter.order && !filter.sort) ||
  (filter.order === 'created_at' && filter.sort === 'desc');
const ARRAY_FILTERS = ['status_id', 'category_id', 'buildings_id', 'performer_id', 'users_id'];

export default {
  name:       "Issues",
  components: {
    IssueSortFilter,
    IssuesRow,
    TasksFilter,
    VuePerfectScrollbar,
    GeneratePlanPopup,
    // HistoryPopup,
  },
  data() {
    return {
      filter: {
        status_id:    [],
        category_id:  [],
        buildings_id: [],
        performer_id: [],
        users_id:     [],
        created_at:   null,
        search:       null,
        sort:         null,
        order:        null,
      },

      searchString:        '',
      issues:              [],
      performers:          [],
      owner:               null,
      issuesInStatusCount: {},

      issuesCount:     0,
      issuesPages:     1,
      page:            1,
      lastUpdateCheck: new Date(),
      requestId:       1,

      isIssuesLoading:   false,
      isExportLoading:   false,
      checkUpdatesTimer: null,
      lastAppliedFilter: null,
    };
  },
  computed: {
    tableFilterStatusId:    {
      get() {
        return this.filter.status_id;
      },
      set( v ) {
        this.filter.status_id = v ? [v] : [];
      },
    },
    tableFilterBuildingId:  {
      get() {
        return this.filter.buildings_id;
      },
      set( v ) {
        this.filter.buildings_id = v ? [v] : [];
      },
    },
    tableFilterPerformerId: {
      get() {
        return this.filter.performer_id;
      },
      set( v ) {
        this.filter.performer_id = v ? [v] : [];
      },
    },
    tableFilterCategoryId:  {
      get() {
        return this.filter.category_id;
      },
      set( v ) {
        this.filter.category_id = v ? [v] : [];
      },
    },
    statuses() {
      const ACCEPTED_STATUS = 2;
      const statuses = Object.values(this.$store.getters['common/tasks/statuses']);
      if (this.issuesInStatusCount && this.issuesInStatusCount[ACCEPTED_STATUS]) return statuses;
      return statuses.filter(status => status.id !== ACCEPTED_STATUS);
    },
    categories() {
      return Object.values(this.$store.getters['common/tasks/newCategories']);
    },
    houses() {
      return this.$store.getters['appUser/housesByPermission']('issues', 'access');
    },
    // unreadMessagesTotal() {
    //   return this.$store.getters['common/tasks/unreadMessagesTotal'];
    // },
  },
  methods:  {
    declOfNum,

    openGeneratePlans() {
      this.$refs.generatePlans.open();
    },

    openHistoryPopup( task ) {
      this.$refs.historyPopup.open(task);
    },

    getStatus( statusId ) {
      return this.$store.getters['common/tasks/statusById'](statusId);
    },

    // getCategoryUnread( categoryId ) {
    //   return this.$store.getters['common/tasks/unreadByCategoryId'](categoryId, this.filter.status_id);
    // },

    getStatusUnread( statusId ) {
      return this.$store.getters['common/tasks/unreadByStatusId'](statusId);
    },

    getAllUnread() {
      return this.$store.getters['common/tasks/unreadMessagesTotal'];
      // return this.$store.getters['common/tasks/unreadByAllCategories'](this.filter.status_id);
    },

    onSearch() {
      this.filter.search = this.searchString || null;
    },

    onSearchClear() {
      this.searchString = '';
      this.onSearch();
    },

    onToggleStatus( status ) {
      const id = status === 'all' ? null : status.id;
      this.filter.status_id = id ? [id] : [];
      // if (id === 3 || id === 4) this.filter.performer_id = [this.$store.getters['appUser/id']]; // "назначена" или "в работе"
    },

    onToggleCategory( category ) {
      this.filter.category_id = category === 'all' ? [] : [category.id];
    },

    onResetUser() {
      this.filter.users_id = [];
    },

    onShowUnassigned() {
      this.filter.status_id = [2];
    },

    onShowNew() {
      this.filter.status_id = [1];
    },

    onClearAll() {
      // this.filter.status_id = [];
      this.filter.created_at = null;
      this.filter.search = null;
      this.filter.category_id = [];
      this.filter.buildings_id = [];
      this.filter.performer_id = [];
    },

    onSetSort( sort, order ) {
      this.filter.sort = sort;
      this.filter.order = order;
    },

    parseQuery() {
      // console.log('parse q');
      const { query } = this.$route;
      const filter = { ...query };

      for (let i = 0; i < ARRAY_FILTERS.length; i++) {
        const key = ARRAY_FILTERS[i];
        const value = filter[key];
        if (!value) {
          this.filter[key] = [];
          continue;
        }
        this.filter[key] = Array.isArray(value)
          ? value.map(id => +id)
          : [+value];
      }

      this.searchString = filter.search || '';
      this.filter.search = filter.search || null;
      this.filter.created_at = filter.created_at ? dateParse(filter.created_at, 'dd.MM.yyyy', new Date()) : null;
      this.filter.sort = filter.sort || null;
      this.filter.order = filter.order || null;
      this.lastAppliedFilter = JSON.stringify(this.filter);
      this.loadFirstPageIssues();
    },

    getRequestFilter() {
      const { created_at, search, sort, order, ...filter } = this.filter;
      const params = {
        ...filter,
        search: search || undefined,
      };
      if (created_at) {
        params.created_at = {
          from: dateStartOfDay(created_at),
          to:   dateEndOfDay(created_at),
        };
      }
      if (sort && order) {
        params.orderby = [sort, order];
      }
      return params;
    },

    loadPerformers() {
      this.$http.get('tasks-performers').then(
        ( { data } ) => this.performers = data,
        () => this.performers = [],
      );
    },

    loadOwner() {
      this.$http.get(`users/${this.filter.users_id[0]}`).then(
        ( { data } ) => this.owner = data,
        () => this.owner = null,
      );
    },

    loadFirstPageIssues() {
      if (this.isIssuesLoading) return;
      this.isIssuesLoading = true;
      this.issues = [];
      this.page = 1;
      this.loadIssues().finally(() => this.isIssuesLoading = false);
    },

    loadIssueUpdates() {
      const lastId = this.issues.reduce(( maxId, issue ) => Math.max(maxId, issue.id), 0);
      if (!lastId) return;

      const params = {
        ...this.getRequestFilter(),
        page:       1,
        created_at: { from: this.lastUpdateCheck.toISOString() },

      };
      this.lastUpdateCheck = new Date();

      this.$http.get('tasks-filtered', { params }).then(( { data: { data: newTasks } } ) => {
        if (!newTasks.length) return;
        let existsIds = this.issues.map(t => t.id);
        newTasks = newTasks.filter(t => !existsIds.includes(t.id));
        if (newTasks.length) {
          this.$vs.notify({
            title:    'Новая заявка!',
            text:     'Поступила новая заявка',
            color:    'success',
            position: 'top-right',
            time:     30000,
          });
          if (isDefaultSort(params)) this.issues.splice(0, 0, ...newTasks);
        }
        // this.issues.splice(0, 0, ...newTasks);
      });
    },

    loadCountIssueInStatuses() {
      this.$http.get('tasks/count_by_status').then(( { data } ) => {
        this.issuesInStatusCount = data.reduce(( dict, item ) => {
          dict[item.status_id] = item.count;
          return dict;
        }, {});
      });
    },

    loadIssues() {
      const params = {
        ...this.getRequestFilter(),
        page: this.page,
      };
      this.requestId++;
      const requestId = this.requestId;

      return this.$http.get('tasks-filtered', { params }).then(
        ( { data } ) => {
          if (this.requestId !== requestId) return;
          this.issues = this.issues.concat(...data.data);
          this.issuesCount = data.total;
          this.totalPages = data.last_page;
        },
        () => this.issues = [],
      );
    },

    loadNextPage() {
      if (this.page + 1 <= this.totalPages) {
        if (this.isIssuesLoading) return;
        this.isIssuesLoading = true;
        this.page = this.page + 1;
        this.loadIssues().finally(() => this.isIssuesLoading = false);
      }
    },

    async exportIssues( emergency = false ) {
      if (this.isExportLoading) return false;
      this.isExportLoading = true;

      this.$http.get('tasks-filtered', { params: this.getRequestFilter() }).then(( { data: tasks } ) => {
        const now = new Date();

        const fileName = emergency
          ? `Аварийные заявки от ${dateFormat(now, 'dd.MM.yyyy HH:mm:ss')}.csv`
          : `Журнал заявок от ${dateFormat(now, 'dd.MM.yyyy HH:mm:ss')}.csv`;

        const template = [
          { header: '№', render: ( row ) => row.id.toString() },
          { header: 'Дата создания', render: ( row ) => dateFormat(new Date(row.created_at), 'dd.MM.yyyy') },
          { header: 'Адрес', render: ( row ) => `"${generateFullAddress(row.apart, row.building)}"` },
          { header: 'Заявитель', render: ( row ) => `"${row.owner ? row.owner.name : '-'}"` },
          { header: 'Статус', render: ( row ) => this.getStatus(row.status_id).name },
          { header: 'Исполнитель', render: ( row ) => `"${row.performer ? row.performer.name : '-'}"` },
          {
            header: 'Телефон', render: ( row ) => {
              const additional = parseJSON(row.additional) || {};
              const phones = [];
              if (row.owner && row.owner.telephone) phones.push(row.owner.telephone);
              if (additional.phone) phones.push(additional.phone);
              return `"${phones.join(', ')}"`;
            },
          },
        ];

        tasks = emergency
          ? tasks.filter(task => [9].includes(task.category_id))
          : tasks.filter(task => ![9].includes(task.category_id));

        exportToCSV({
          fileName,
          template,
          data: tasks,
        });
      }).finally(() => this.isExportLoading = false);
    },
  },

  created() {
    this.parseQuery();
    this.loadPerformers();
    if (this.filter.users_id.length) this.loadOwner();
  },

  mounted() {
    this.checkUpdatesTimer = setInterval(() => {
      this.loadIssueUpdates();
      this.loadCountIssueInStatuses();
    }, 10000);
    this.loadCountIssueInStatuses();
  },

  beforeDestroy() {
    clearInterval(this.checkUpdatesTimer);
  },

  watch: {
    '$route.query'( value, prevValue ) {
      // console.log(JSON.stringify(value));
      // console.log(JSON.stringify(prevValue));
      this.parseQuery();
    },
    filter: {
      deep: true,
      handler( filter ) {
        const strValue = JSON.stringify(filter);
        if (strValue === this.lastAppliedFilter) return;

        const query = {};
        for (let i = 0; i < ARRAY_FILTERS.length; i++) {
          const key = ARRAY_FILTERS[i];
          const value = filter[key];
          if (value && value.length) query[key] = value.length === 1 ? ['' + value[0]] : value.map(id => '' + id);
        }
        if (filter.search) query.search = filter.search;
        if (filter.created_at) query.created_at = dateFormat(filter.created_at, 'dd.MM.yyyy');
        if (filter.sort) query.sort = filter.sort;
        if (filter.order) query.order = filter.order;
        this.$router.push({ query });
        this.lastAppliedFilter = strValue;
      },
    },
  },
};
</script>

<style lang="scss" module>
.container {
  flex: 1;
  position: relative;
}

.panel {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.body {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
}

.title {
  line-height: 1.1;
  font-size: 20px;
  font-weight: 500;
  color: rgba(var(--app-heading-color), 1);
}

.row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

}

.rowLabel {
  font-size: 1.1em;
  font-weight: 500;
  margin-right: 10px;
}

.rowContent {
  flex: 1;
}

.search {
  //flex: 1;
  //margin: 0 20px;
  flex: 1;
  max-width: 460px;
  position: relative;
}

.searchInput {
  font: inherit;
  width: 100%;
  border: 1px solid #979797;
  height: 30px;
  border-radius: 15px;
  padding: 0 30px;
}

.searchIcon {
  position: absolute;
  top: 8px;
  left: 8px;
  color: #6D6D6D;
  pointer-events: none;
}

.searchClear {
  position: absolute;
  right: 12px;
  top: 9px;
  background: transparent;
  border: 0;
  border-radius: 0;
  opacity: .7;
  cursor: pointer;
  @include anim();

  &:hover {
    opacity: 1;
  }
}

.buttons {
  display: flex;
  align-items: center;
}

.exportMenu {
  max-width: 180px;
  width: calc(100% - 10px);
}

.exportButton {
  position: relative;

  :global(.block-loading) {
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(#fff, .7);

    &:before {
      width: 18px;
      height: 18px;
    }
  }
}

.exportItem {
  line-height: 1.2;
  padding: 5px 10px;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: rgba(var(--app-heading-color), 1);
  }
}

.filters {
  flex: 0;
  //text-align: right;
  //height: 45px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 -8px;
  //margin-bottom: 10px;

  :global(.tasks-filter__values ) {
    //  left: auto;
    //  right: 0;
    //  text-align: left;
    width: 100vw;
    max-width: 400px;
  }
}

.filtersTitle {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: .3rem;
}

.filterClear {
  border: 0;
  padding: 0;
  margin: 0;
  margin-left: 1rem;
  font: inherit;
  font-size: 1rem;
  font-weight: 400;
  appearance: none;
  background-color: transparent;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
}

//.filters {
//  display: flex;
//  align-items: center;
//  justify-content: flex-start;
//  margin: 0 -10px;
//}
//
//.filter {
//  margin: 0 10px;
//}

.types {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #F2F2F2;
  margin-bottom: 25px;
}

.typeTitle {
  font-size: 1.15em;
  margin-right: 1em;
}

.type {
  position: relative;
  margin: 0 2px;
  background: #F2F2F2;
  height: 50px;
  padding: 0 7px;
  display: flex;
  align-items: center;
  flex: 0;
  border: 1px solid #F2F2F2;
  border-top: 2px solid var(--color);
  border-bottom: 0;
  cursor: pointer;
  @include anim();

  &:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 2px;
    @include anim();
  }
}

.typeActive {
  background: #FFFFFF;

  &:after {
    background: #FFFFFF;
  }

  .typeLabel {
    background: #FE9F44;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }
}

.typeText {
  font-size: 1.1em;
  line-height: 1;
  opacity: .5;
  font-weight: 500;
  white-space: nowrap;
}

.typeLabel {
  flex-shrink: 0;
  color: #ffffff;
  background: #A9A9A9;
  border-radius: 15px;
  height: 25px;
  min-width: 25px;
  display: flex;
  align-items: center;
  padding: 0 5px;
  font-weight: 500;
  margin-left: 1em;
  @include anim();
}

.hint {
  font-size: 1.25em;
  margin-bottom: 25px;
}

.filterStatus {
  width: 160px;
}

.filterDate {
  width: 135px;
  //margin-left: .5em;
}

.filterHouse {
  width: 370px;
}

.filterPerformer {
  min-width: 200px;
}

.filterCategory {
  width: 165px;
  margin-left: auto;
}

.filterSelected {
  font-size: .95rem;
  line-height: 1;
  padding: 3px;
  background: #eee;
  border-radius: 2px;
  margin: -3px;
}

.filterDeselect {
  background-color: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  margin-left: .3em;
  cursor: pointer;
}

.filterLabel {
  padding-left: 5px;
  font-size: .85rem;
  color: rgba(var(--app-heading-color-light), 1);
}

.tableWrapper {
  flex: 1;
  margin: 0 -15px;
  padding: 15px;
}

.table {
  border-collapse: collapse;
  width: 100%;

  th {
    font-weight: normal;
    padding: 0 13px 6px;
    //font-size: 1.1em;
    border-bottom: 1px solid #CCCCCC;
    vertical-align: top;
    font-size: 13px;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 20px;
    }
  }
}

.total {
  font-size: 1.05em;
  margin-top: .3em;
}
</style>
